import HelloWorld from '@/components/HelloWorld'
const routes = [{
  path: '/',
  name: 'index',
  component: resolve => require(['../views/index'], resolve)
}, {
  path: '/message',
  name: 'message',
  component: resolve => require(['../views/message/index'], resolve)
}, {
  path: '/personalCenter',
  name: 'personalCenter',
  component: resolve => require(['../views/personalCenter/index'], resolve)
}, {
  path: '/myMemoryPage',
  name: 'myMemoryPage',
  component: resolve => require(['../views/myMemoryPage/index'], resolve)
}, {
  path: '/myOrderPage',
  name: 'myOrderPage',
  component: resolve => require(['../views/myOrderPage/index'], resolve)
}, {
  path: '/helpPage',
  name: 'helpPage',
  component: resolve => require(['../views/helpPage/index'], resolve)
}, {
  path: '/softwareLibrary',
  name: 'softwareLibrary',
  component: resolve => require(['../views/softwareLibrary/index'], resolve)
}, {
  path: '/shoppingMall',
  name: 'shoppingMall',
  component: resolve => require(['../views/shoppingMall/index'], resolve)
}, {
  path: '/workingChannel',
  name: 'workingChannel',
  component: resolve => require(['../views/workingChannel/index'], resolve)
}, {
  path: '/technicalSupport',
  name: 'technicalSupport',
  component: resolve => require(['../views/technicalSupport/index'], resolve)
}, {
  path: '/maintenance',
  name: 'maintenance',
  component: resolve => require(['../views/technicalSupport/maintenance'], resolve)
}, {
  path: '/softwareManual',
  name: 'softwareManual',
  component: resolve => require(['../views/technicalSupport/softwareManual'], resolve)
}, {
  path: '/about',
  name: 'about',
  component: resolve => require(['../views/about/index'], resolve)
}, {
  path: '/newsMore',
  name: 'newsMore',
  component: resolve => require(['../views/about/newsMore'], resolve)
}, {
  path: '/softwareLearnMore',
  name: 'softwareLearnMore',
  component: resolve => require(['../views/softwareLearnMore/indexSec'], resolve)
}, {
  path: '/softwareMoudle',
  name: 'softwareMoudle',
  component: resolve => require(['../views/softwareMoudle/index'], resolve)
}, {
  path: '/cardActivation',
  name: 'cardActivation',
  component: resolve => require(['../views/cardActivation/index'], resolve)
}, {
  path: '/newsDetails',
  name: 'newsDetails',
  component: resolve => require(['../views/newsDetails/index'], resolve)
}, {
  path: '/shoppingMallLearnMore',
  name: 'shoppingMallLearnMore',
  component: resolve => require(['../views/shoppingMallLearnMore/index'], resolve)
}, {
  path: '/printerDetail',
  name: 'printerDetail',
  component: resolve => require(['../views/shoppingMallLearnMore/printerDetail'], resolve)
}, {
  path: '/shoppingMallBuy',
  name: 'shoppingMallBuy',
  component: resolve => require(['../views/shoppingMallBuy/index'], resolve)
}, {
  path: '/termsOfUse',
  name: 'termsOfUse',
  component: resolve => require(['../views/agreeOnPage/termsOfUse'], resolve)
}, {
  path: '/salesPolicy',
  name: 'salesPolicy',
  component: resolve => require(['../views/agreeOnPage/salesPolicy'], resolve)
}, {
  path: '/privacyPolicy',
  name: 'privacyPolicy',
  component: resolve => require(['../views/agreeOnPage/privacyPolicy'], resolve)
}, {
  path: '/legalInformation',
  name: 'legalInformation',
  component: resolve => require(['../views/agreeOnPage/legalInformation'], resolve)
}, {
  path: '/purchaseAgreement',
  name: 'purchaseAgreement',
  component: resolve => require(['../views/agreeOnPage/purchaseAgreement'], resolve)
}, {
  path: '/HelloWorld',
  name: 'HelloWorld',
  component: HelloWorld
}, {
  path: '/animatePage',
  name: 'animatePage',
  component: resolve => require(['../views/animatePage'], resolve)
}, {
  path: '/Manual/:id?',
  component: resolve => require(['../views/Manual'], resolve)
}, {
  path: '/update/:id?',
  component: resolve => require(['../views/update'], resolve)
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/router.js